var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{class:_vm.spinnerClasses,attrs:{"title":"loading"}}),_vm._v(" "),(!_vm.spinnerOnly)?_c('span',{staticClass:"loading-message"},[_vm._v(_vm._s(_vm.message)+"."),_c('span',{staticClass:"blinking"},[_vm._v("..")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }